import { VisitRequestTableRowFragment } from '@/components/bulkQueue/tables/queries.gql.types';
import { CellProps, VisitCellProps, VisitRequestCellProps } from '@/components/bulkQueue/types';
import { CaptionLabel } from '@/components/labels/CaptionLabel';
import { NoneLabel } from '@/components/labels/NoneLabel';
import { VerticalStack } from '@/components/utils/linearLayouts';
import { Typography } from '@mui/material';
import { FC } from 'react';

export interface IDisciplineDisplay {
    id: string;
    displayName: string;
}

const ServicesVisitRequestCell: FC<VisitRequestCellProps> = (props) => {
    const { appointments } = props.entity;

    return (
        <VerticalStack>
            {appointments.length > 0 ? (
                appointments.map((appointment) => (
                    <VerticalStack key={appointment.id}>
                        {appointment.services.length > 0 ? (
                            appointment.services.map((service) => (
                                <Typography key={service.id} fontSize={'0.9em'}>
                                    {service.name}
                                </Typography>
                            ))
                        ) : (
                            <NoneLabel text='No services' fontSize={'0.9em'} />
                        )}
                    </VerticalStack>
                ))
            ) : (
                <NoneLabel text='No services' fontSize={'0.9em'} />
            )}
        </VerticalStack>
    );
};

const ServicesVisitCell: FC<VisitCellProps> = (props) => {
    const { appointments } = props.entity;

    return (
        <VerticalStack>
            {appointments && appointments.length > 0 ? (
                appointments.map((appointment) => (
                    <VerticalStack key={appointment.id}>
                        {appointment.services.length > 0 ? (
                            appointment.services.map((service) => (
                                <Typography key={service.id} fontSize={'0.9em'}>
                                    {service.name}
                                </Typography>
                            ))
                        ) : (
                            <NoneLabel text='No services' fontSize={'0.9em'} />
                        )}
                    </VerticalStack>
                ))
            ) : (
                <NoneLabel text='No services' fontSize={'0.9em'} />
            )}
        </VerticalStack>
    );
};

export const ServicesRenderCell: FC<CellProps> = (props) => {
    const { entity } = props;

    switch (entity.__typename) {
        case 'Visit':
            return <ServicesVisitCell entity={entity} />;
        case 'VisitRequest':
            return <ServicesVisitRequestCell entity={entity} />;
        default:
            return null;
    }
};

type AppointmentDisciplineServicesCellProps = {
    disciplines: IDisciplineDisplay[];
    appointments: VisitRequestTableRowFragment['appointments'];
};

export const AppointmentDisciplineServicesCell: FC<AppointmentDisciplineServicesCellProps> = (
    props,
) => {
    const { disciplines, appointments } = props;

    return (
        <VerticalStack>
            <CaptionLabel fontSize={'0.8em'}>
                {disciplines.length > 0
                    ? disciplines.map((discipline) => discipline.displayName).join(', ')
                    : 'Services'}
            </CaptionLabel>
            {appointments.length > 0 ? (
                appointments.map((appointment) => (
                    <VerticalStack key={appointment.id}>
                        {appointment.services.length > 0 ? (
                            appointment.services.map((service) => (
                                <Typography key={service.id} fontSize={'0.9em'}>
                                    {service.name}
                                </Typography>
                            ))
                        ) : (
                            <NoneLabel text='No services' fontSize={'0.9em'} />
                        )}
                    </VerticalStack>
                ))
            ) : (
                <NoneLabel text='No services' fontSize={'0.9em'} />
            )}
        </VerticalStack>
    );
};
